export type AuthUser = { email: string };

const AUTH_KEY = "ufm_admin_auth_user";

export function getCurrentUser(): AuthUser | null {
  const raw = localStorage.getItem(AUTH_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as AuthUser;
  } catch {
    return null;
  }
}

export function isAuthenticated(): boolean {
  // Only trust the API token; ignore stale mock user objects.
  const token = localStorage.getItem("t");
  return Boolean(token && token.length > 0);
}

export function login(
  email: string,
  password: string
): Promise<{ success: boolean; error?: string }> {
  return new Promise((resolve) => {
    setTimeout(() => {
      // Mock authentication - in production, this would call your API
      const validEmail = email === "admin@ufamilymedicine.com";
      const validPassword = password === "admin123";

      if (!validEmail || !validPassword) {
        resolve({ success: false, error: "Invalid email or password" });
        return;
      }

      if (validEmail && validPassword) {
        localStorage.setItem(AUTH_KEY, JSON.stringify({ email }));
      }
      resolve({ success: true });
    }, 600);
  });
}

export function logout(): void {
  localStorage.removeItem(AUTH_KEY);
  localStorage.removeItem("t");
}
